import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Box, Typography, useMediaQuery, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CandleChart from './CandleChart';

// Define the new leaner structure for historical rate entries
// In a real app, this would be in a shared types file
interface HistoricalRateEntry {
  id?: string;
  recordedAt: string;
  quantityFrom: string | number;
  quantityTo: string | number;
  exchangeRate?: number;
}

interface CandleChartModalProps {
  open: boolean;
  onClose: () => void;
  historicalRates: HistoricalRateEntry[]; // Updated to use HistoricalRateEntry
  isLoading: boolean;
  selectedItemName: string;
  selectedCurrencyName: string;
  leagueName?: string; // Add leagueName prop
}

const CandleChartModal: React.FC<CandleChartModalProps> = ({
  open,
  onClose,
  historicalRates,
  isLoading,
  selectedItemName,
  selectedCurrencyName,
  leagueName, // Add leagueName to destructuring
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Dialog open={open} onClose={onClose} fullScreen={fullScreen} maxWidth='lg' fullWidth aria-labelledby='candle-chart-dialog-title'>
      <DialogTitle id='candle-chart-dialog-title'>
        <Box display='flex' alignItems='center' justifyContent='space-between'>
          <Typography variant='h6'>Candlestick Price Analysis</Typography>
          <IconButton edge='end' color='inherit' onClick={onClose} aria-label='close'>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        <CandleChart
          historicalRates={historicalRates}
          selectedItemName={selectedItemName}
          selectedCurrencyName={selectedCurrencyName}
          isLoading={isLoading}
          leagueName={leagueName} // Pass leagueName to CandleChart
        />
      </DialogContent>
    </Dialog>
  );
};

export default CandleChartModal;
